(function () {
  'use strict';

  var EDM_POPUP_COOLDOWN_KEY = 'edm_popup_cooldown_until';
  var EDM_POPUP_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
  var SCROLL_TRIGGER_PERCENT = 15;
  // Facebook community entry is shown on all top-level navigation pages, all markets.
  var eligiblePathSegments = [
    '/',
    '/pages/strutt-ev1',
    '/pages/strutt-ev1c',
    '/pages/about-us',
    '/pages/support',
    '/blogs/updates'
  ];

  function initGlobalCommunity() {
    if (window.__struttGlobalCommunityInitialized) return;
    window.__struttGlobalCommunityInitialized = true;

    var config = window.StruttGlobalCommunityConfig || {};
    var EDM_DEBUG =
      new URLSearchParams(window.location.search).has('edm_debug') ||
      (function () {
        try {
          return window.localStorage.getItem('edm_popup_debug') === 'true';
        } catch (error) {
          return false;
        }
      })();

    function edmLog() {
      if (!EDM_DEBUG) return;
      // eslint-disable-next-line no-console
      console.log.apply(console, ['[EDM]'].concat(Array.prototype.slice.call(arguments)));
    }

    function safeGetItem(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function safeSetItem(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {}
    }

    function safeRemoveItem(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {}
    }

    function decodeHtmlEntities(value) {
      var text = String(value || '');
      if (!text || text.indexOf('&') === -1) {
        return text;
      }
      var parser = document.createElement('textarea');
      parser.innerHTML = text;
      return parser.value;
    }

    var communityTriggerEntry = document.querySelector('[data-global-community-entry]');
    var supportToggle = document.querySelector('.global-support-toggle');
    if (supportToggle && communityTriggerEntry) {
      var supportMobile = window.matchMedia('(max-width: 734px)');
      function closeSupportPanel(returnFocus) {
        supportToggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) supportToggle.focus();
      }
      supportToggle.addEventListener('click', function () {
        supportToggle.setAttribute('aria-expanded', String(supportToggle.getAttribute('aria-expanded') !== 'true'));
      });
      document.addEventListener('click', function (event) {
        if (!communityTriggerEntry.contains(event.target)) closeSupportPanel(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && supportToggle.getAttribute('aria-expanded') === 'true') {
          closeSupportPanel(true);
        }
      });
      supportMobile.addEventListener('change', function () { closeSupportPanel(false); });
    }
    var communityTrigger = document.querySelector('[data-global-community-trigger]');
    var communityTriggerLabel = communityTrigger ? communityTrigger.querySelector('[data-community-label]') : null;
    var edmModal = document.querySelector('[data-edm-modal]');
    var edmOverlay = edmModal ? edmModal.querySelector('.global-community-modal__overlay') : null;
    var edmCloseButtons = edmModal ? edmModal.querySelectorAll('[data-edm-close]') : [];
    var newsletterContainer = edmModal ? edmModal.querySelector('[data-global-community-newsletter]') : null;
    var modalCtaContainer = edmModal ? edmModal.querySelector('[data-global-community-modal-cta]') : null;
    var edmForm = document.getElementById('theme-edm-newsletter-form');
    var edmEmailInput = document.getElementById('theme-edm-email-input');
    var edmMessage = document.getElementById('theme-edm-email-message');
    var FB_REDIRECT_CHANNEL = {
      facebookIcon: 0,
      emailSubmit: 1
    };
    var FB_JOIN_AD_VALUE = {
      facebookIcon: 60,
      emailSubmit: 10
    };

    function getThemeMarketCode() {
      try {
        if (typeof window.getMarketCode === 'function') {
          return String(window.getMarketCode() || '').toLowerCase();
        }
      } catch (error) {}

      return String(config.market || '').toLowerCase();
    }

    function getCommunityTrackingSite() {
      var path = String(window.location.pathname || config.currentPath || '').toLowerCase();
      var rootPath = String(config.rootPath || '').toLowerCase();
      var marketCode = getThemeMarketCode();
      var isGermanPath = /^\/(?:de-eu|de)(?=\/|$)/.test(path) || /^\/(?:de-eu|de)(?=\/|$)/.test(rootPath);
      var isFrenchPath = /^\/(?:fr-eu|fr)(?=\/|$)/.test(path) || /^\/(?:fr-eu|fr)(?=\/|$)/.test(rootPath);
      var isCanadaPath = /^\/en-ca(?=\/|$)/.test(path) || /^\/en-ca(?=\/|$)/.test(rootPath);

      if (config.isUkMarket || marketCode === 'uk' || path.indexOf('/en-uk') === 0 || rootPath.indexOf('/en-uk') === 0) {
        return 'uk';
      }
      // The Canada storefront shares the SG host, so its market/path must take precedence over the host fallback.
      if (marketCode === 'ca' || String(config.market || '').toLowerCase() === 'ca' || isCanadaPath) {
        return 'ca';
      }
      if (config.isSgMarket || marketCode === 'sg' || window.location.hostname === 'strutt.inc' || window.location.hostname === 'www.strutt.inc') {
        return 'sg';
      }
      if (isGermanPath) {
        return 'de';
      }
      if (isFrenchPath) {
        return 'fr';
      }

      return '';
    }

    function shouldUseLocalizedFbJoinTracking() {
      var trackingSite = getCommunityTrackingSite();
      return trackingSite === 'sg' || trackingSite === 'ca' || trackingSite === 'uk' || trackingSite === 'de' || trackingSite === 'fr';
    }

    function getNormalizedPathname() {
      var pathname = window.location.pathname || '';
      pathname = pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');
      return pathname.replace(/\/+$/, '') || '/';
    }

    function getCommunityPageName() {
      var pathname = getNormalizedPathname();
      var pageNameMap = {
        '/': 'home',
        '/pages/strutt-ev1': 'strutt_ev1',
        '/pages/strutt-ev1c': 'strutt_ev1c',
        '/pages/about-us': 'about_us',
        '/pages/partnership': 'contact_us',
        '/pages/support': 'support',
        '/blogs/updates': 'updates'
      };

      if (pageNameMap[pathname]) {
        return pageNameMap[pathname];
      }

      return pathname
        .replace(/^\/+|\/+$/g, '')
        .replace(/[^a-z0-9]+/gi, '_')
        .replace(/^_+|_+$/g, '') || 'unknown';
    }

    function getThemeMarketVariant() {
      var configMarket = String(config.market || '').toLowerCase();
      if (config.isSgMarket) return 'sg';
      if (config.isUkMarket) return 'uk';
      if (config.isEuMarket) return 'eu';

      try {
        if (typeof window.getMarketCode === 'function') {
          var marketCode = String(window.getMarketCode() || '').toLowerCase();
          if (marketCode === 'sg' || marketCode === 'uk' || marketCode === 'eu' || marketCode === 'us') {
            return marketCode;
          }
        }
      } catch (error) {}

      if (configMarket === 'sg' || configMarket === 'uk' || configMarket === 'eu' || configMarket === 'us') {
        return configMarket;
      }

      return 'default';
    }

    function isEligibleCommunityPage() {
      var normalizedPathname = getNormalizedPathname();
      return eligiblePathSegments.some(function (segment) {
        return normalizedPathname === segment;
      });
    }

    function callClarity(method, key, value) {
      if (!window || typeof window.clarity !== 'function') {
        return;
      }
      try {
        if (arguments.length >= 3) {
          window.clarity(method, key, value);
          return;
        }
        window.clarity(method, key);
      } catch (error) {
        console.error('[Clarity] Error:', error);
      }
    }

    function isUSMarket() {
      try {
        return getThemeMarketCode() === 'us';
      } catch (error) {}
      return false;
    }

    function isSingaporeMarket() {
      return getCommunityTrackingSite() === 'sg';
    }

    function isCanadaMarket() {
      return getCommunityTrackingSite() === 'ca';
    }

    function reportFbPageRedirect(channel) {
      var normalizedChannel = Number(channel) === FB_REDIRECT_CHANNEL.emailSubmit
        ? FB_REDIRECT_CHANNEL.emailSubmit
        : FB_REDIRECT_CHANNEL.facebookIcon;
      var pageName = getCommunityPageName();

      callClarity('set', 'fb_redirect_channel', String(normalizedChannel));
      callClarity('set', 'page_name', pageName);
      callClarity('event', 'fb_page_redirect');
    }

    function reportFbJoinAdsEvent(channel) {
      if (!window.IS_PRODUCTION) return;
      if (!isUSMarket() && !shouldUseLocalizedFbJoinTracking()) return;

      var normalizedChannel = Number(channel) === FB_REDIRECT_CHANNEL.emailSubmit
        ? FB_REDIRECT_CHANNEL.emailSubmit
        : FB_REDIRECT_CHANNEL.facebookIcon;
      var eventValue = normalizedChannel === FB_REDIRECT_CHANNEL.emailSubmit
        ? FB_JOIN_AD_VALUE.emailSubmit
        : FB_JOIN_AD_VALUE.facebookIcon;
      var eventParams = {
        value: eventValue,
        currency: isUSMarket() || isSingaporeMarket() || isCanadaMarket() ? 'USD' : 'EUR'
      };

      // Meta Pixel - for Facebook ads optimization
      if (typeof window.reportMetaPixelEvent === 'function') {
        window.reportMetaPixelEvent((window.META_PIXEL_EVENTS || {}).joinFbGroupWithEmail, eventParams);
      }
    }

    function reportRokuCommunitySubscription(value) {
      if (!window.IS_US_PRODUCTION || !isUSMarket() || typeof window.rkp !== 'function') return;
      window.rkp('event', 'SUBSCRIBE', {
        content_name: 'Join FB Group',
        value: value,
        currency: 'USD'
      });
    }

    function trackFbRedirect(channel) {
      reportFbPageRedirect(channel);
      reportFbJoinAdsEvent(channel);
    }

    var themeMarketVariant = getThemeMarketVariant();

    if (!isEligibleCommunityPage()) {
      edmLog('skip: not eligible page', { pathname: window.location.pathname, eligiblePathSegments: eligiblePathSegments });
      return;
    }

    if (!communityTrigger || !edmModal) {
      edmLog('skip: missing required DOM', {
        hasCommunityTriggerEntry: Boolean(communityTriggerEntry),
        hasCommunityTrigger: Boolean(communityTrigger),
        hasEdmModal: Boolean(edmModal)
      });
      return;
    }

    var lastFocusedElement = null;
    var scrollLocked = false;
    var scrollLockCount = 0;
    var scrollLockY = 0;

    // Promo coupon tracking kept for potential reuse; not wired while promo CTA is retired.
    // function getStoredCommunityTrackingParams() {
    //   var result = {};
    //   try {
    //     if (typeof window.getStoredOrderTrackingParams === 'function') {
    //       result = window.getStoredOrderTrackingParams() || {};
    //     }
    //   } catch (error) {}
    //   return {
    //     utm_source: String(result.utm_source || '').trim(),
    //     utm_campaign: String(result.utm_campaign || '').trim(),
    //     utm_content: String(result.utm_content || '').trim()
    //   };
    // }
    //
    // function trackGlobalCommunityTriggerClick(destinationUrl) {
    //   if (getNormalizedPathname() !== '/pages/strutt-ev1') return;
    //   if (typeof window.trackClick !== 'function') return;
    //   var trackingParams = getStoredCommunityTrackingParams();
    //   var payload = {
    //     page_id: 'P-co-lp',
    //     section_id: 'global-community-trigger',
    //     cta_name: 'global_community_trigger',
    //     behavior: 'go_coupon'
    //   };
    //   if (trackingParams.utm_source) payload.utm_source = trackingParams.utm_source;
    //   if (trackingParams.utm_campaign) payload.utm_campaign = trackingParams.utm_campaign;
    //   if (trackingParams.utm_content) payload.utm_content = trackingParams.utm_content;
    //   if (destinationUrl) payload.link_url = String(destinationUrl).trim();
    //   window.trackClick('select_ces_coupon', payload);
    // }
    //
    // function getGoogleAdsConversion(conversionKey) {
    //   var conversions = window.GOOGLE_ADS_CONVERSIONS || {};
    //   return conversions[conversionKey] || '';
    // }
    //
    // function navigateWithGoogleAdsConversion(destinationUrl, conversionKey) {
    //   var url = String(destinationUrl || '').trim();
    //   if (!url) return;
    //   var didNavigate = false;
    //   var navigate = function () {
    //     if (didNavigate) return;
    //     didNavigate = true;
    //     window.location.href = url;
    //   };
    //   if (window.IS_PRODUCTION && typeof window.reportGoogleAdsConversion === 'function') {
    //     window.reportGoogleAdsConversion(getGoogleAdsConversion(conversionKey), navigate);
    //   } else {
    //     navigate();
    //   }
    //   if (window.IS_PRODUCTION && typeof window.reportMetaPixelEvent === 'function') {
    //     window.reportMetaPixelEvent((window.META_PIXEL_EVENTS || {})[conversionKey]);
    //   }
    // }
    //
    // function bindPromoCouponConversionClick(element, getDestinationUrl, conversionKey) {
    //   if (!element) return;
    //   element.addEventListener('click', function (event) {
    //     event.preventDefault();
    //     var destinationUrl = typeof getDestinationUrl === 'function'
    //       ? getDestinationUrl()
    //       : element.getAttribute('href');
    //     trackGlobalCommunityTriggerClick(destinationUrl);
    //     navigateWithGoogleAdsConversion(destinationUrl, conversionKey);
    //   });
    // }

    function isEventInsideModal(event) {
      try {
        return Boolean(event && event.target && event.target.closest && event.target.closest('.global-community-modal__content'));
      } catch (error) {
        return false;
      }
    }

    function preventBackgroundScroll(event) {
      if (!scrollLocked) return;
      if (isEventInsideModal(event)) return;
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
    }

    function lockScroll() {
      scrollLockCount += 1;
      if (scrollLocked) return;
      scrollLocked = true;
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('global-community-modal-open');
      document.body.classList.add('global-community-modal-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', preventBackgroundScroll, { passive: false, capture: true });
      document.addEventListener('wheel', preventBackgroundScroll, { passive: false, capture: true });
    }

    function unlockScroll() {
      scrollLockCount = Math.max(0, scrollLockCount - 1);
      if (!scrollLocked || scrollLockCount > 0) return;
      scrollLocked = false;
      document.documentElement.classList.remove('global-community-modal-open');
      document.body.classList.remove('global-community-modal-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('touchmove', preventBackgroundScroll, true);
      document.removeEventListener('wheel', preventBackgroundScroll, true);
      window.scrollTo(0, scrollLockY);
    }

    function getFocusableElements(modal) {
      return Array.from(
        modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return !element.hasAttribute('disabled') && element.offsetParent !== null;
      });
    }

    function openModal(modal) {
      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      lockScroll();
      var focusableElements = getFocusableElements(modal);
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }

    function closeModal(modal) {
      modal.hidden = true;
      unlockScroll();
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function showCommunityTrigger() {
      if (communityTriggerEntry) {
        communityTriggerEntry.removeAttribute('aria-hidden');
        communityTriggerEntry.classList.add('is-visible');
      }
    }

    function setCommunityTriggerMode(mode) {
      if (!communityTriggerEntry || !communityTrigger) return;
      // Reuse promo visual styles for the Facebook community pill button.
      var isFacebookMode = mode === 'facebook';
      communityTriggerEntry.classList.toggle('global-community-entry--take-drive', false);
      communityTriggerEntry.classList.toggle('global-community-entry--promo', isFacebookMode);
      if (communityTriggerLabel) {
        communityTrigger.setAttribute('aria-label', communityTriggerLabel.textContent || 'Join Facebook Group');
      }
    }

    function setGlobalCommunityModalContent(content) {
      if (!edmModal || !content) return;
      var modalTitle = edmModal.querySelector('[data-global-community-modal-title]');
      var modalDescription = edmModal.querySelector('[data-global-community-modal-description]');
      var ctaContainer = edmModal.querySelector('[data-global-community-modal-cta]');
      var ctaButton = ctaContainer ? ctaContainer.querySelector('.website-display-button') : null;
      var ctaButtonText = ctaButton ? ctaButton.querySelector('.website-display-button__text') : null;

      if (modalTitle && typeof content.title === 'string') {
        modalTitle.innerHTML = decodeHtmlEntities(content.title).replace(/\n/g, '<br>');
      }
      if (modalDescription && typeof content.description === 'string') {
        modalDescription.textContent = decodeHtmlEntities(content.description);
      }
      if (ctaButton) {
        if (typeof content.buttonUrl === 'string' && content.buttonUrl) {
          ctaButton.setAttribute('href', content.buttonUrl);
        }
        if (typeof content.buttonTarget === 'string' && content.buttonTarget) {
          ctaButton.setAttribute('target', content.buttonTarget);
          if (content.buttonTarget === '_blank') {
            ctaButton.setAttribute('rel', 'noopener noreferrer');
          } else {
            ctaButton.removeAttribute('rel');
          }
        } else {
          ctaButton.removeAttribute('target');
          ctaButton.removeAttribute('rel');
        }
      }
      if (ctaButtonText && typeof content.buttonLabel === 'string' && content.buttonLabel) {
        ctaButtonText.textContent = decodeHtmlEntities(content.buttonLabel);
      }
    }

    function setNewsletterVisibility(visible) {
      if (!newsletterContainer) return;
      newsletterContainer.hidden = !visible;
      if (!visible && edmMessage) {
        edmMessage.style.display = 'none';
      }
    }

    function setModalCtaVisibility(visible) {
      if (!modalCtaContainer) return;
      modalCtaContainer.hidden = !visible;
    }

    function getEdmPopupCooldownUntil() {
      return Number(safeGetItem(EDM_POPUP_COOLDOWN_KEY) || 0);
    }

    function isEdmPopupInCooldown() {
      return getEdmPopupCooldownUntil() > Date.now();
    }

    function setEdmPopupCooldown() {
      safeSetItem(EDM_POPUP_COOLDOWN_KEY, String(Date.now() + EDM_POPUP_COOLDOWN_MS));
    }

    function handleModalKeydown(event) {
      var activeModal = edmModal && !edmModal.hidden ? edmModal : null;
      if (!activeModal) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(activeModal);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusableElements = getFocusableElements(activeModal);
      if (focusableElements.length === 0) {
        event.preventDefault();
        activeModal.querySelector('.global-community-modal__content').focus();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    function registerModalCloseButtons() {
      if (!edmModal) return;
      edmModal.addEventListener('click', function (event) {
        var closeButton = event && event.target && event.target.closest
          ? event.target.closest('[data-edm-close]')
          : null;
        if (!closeButton || !edmModal.contains(closeButton)) return;
        closeModal(edmModal);
      });
    }

    function registerModalInteractionDebug() {
      if (!edmModal) return;

      if (edmOverlay) {
        edmOverlay.addEventListener('click', function () {
          edmLog('interaction: overlay close', { pageName: getCommunityPageName() });
        });
      }

      Array.prototype.forEach.call(edmCloseButtons, function (button) {
        button.addEventListener('click', function () {
          edmLog('interaction: close button', { pageName: getCommunityPageName() });
        });
      });
    }


    function setupAutoTrigger(openHandler) {
      edmLog('init', {
        pathname: window.location.pathname,
        scrollTriggerPercent: SCROLL_TRIGGER_PERCENT,
        frequencyCap: '3-days',
        modal: 'facebook-community'
      });

      var edmTriggered = false;

      if (isEdmPopupInCooldown()) {
        edmLog('skip: popup in cooldown', {
          cooldownUntil: getEdmPopupCooldownUntil()
        });
        return;
      }

      function triggerEdm(reason) {
        if (edmTriggered) return;
        edmTriggered = true;
        setEdmPopupCooldown();
        edmLog('trigger: open facebook community modal', { reason: reason });
        openHandler();
        window.removeEventListener('scroll', checkScroll);
      }

      function checkScroll() {
        var pageHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
        if (pageHeight <= 0) return;
        // Trigger when the user has scrolled to 25% of the full page height.
        var scrollPercent = (window.scrollY / pageHeight) * 100;
        if (scrollPercent >= SCROLL_TRIGGER_PERCENT) {
          triggerEdm('scroll');
        }
      }

      window.addEventListener('scroll', checkScroll, { passive: true });
      checkScroll();
    }

    function validateEmail(value) {
      if (!value || !value.trim()) {
        return {
          isValid: false,
          errorMessage: getNewsletterMessage('fieldRequired', 'Please fill in this information.')
        };
      }

      var trimmedValue = value.trim();
      if (trimmedValue.length < 6) {
        return {
          isValid: false,
          errorMessage: getNewsletterMessage('emailInvalid', 'Email format incorrect, please try again.')
        };
      }

      if (/[\u4e00-\u9fa5]/.test(trimmedValue)) {
        return {
          isValid: false,
          errorMessage: getNewsletterMessage('emailInvalid', 'Email format incorrect, please try again.')
        };
      }

      var emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
      if (!emailRegex.test(trimmedValue)) {
        return {
          isValid: false,
          errorMessage: getNewsletterMessage('emailInvalid', 'Email format incorrect, please try again.')
        };
      }

      return { isValid: true, errorMessage: '' };
    }

    function subscribeNewsletter(email) {
      var baseURL = window.API_BASE_URL || '';
      var url = baseURL + '/authority/account/subscription';
      var formData = new FormData();
      formData.append('email', email);

      return fetch(url, {
        method: 'POST',
        headers: {
          'X-Client-Type': 'web'
        },
        body: formData
      }).catch(function () {
        return null;
      }).then(function (response) {
        if (!response) {
          return { code: 0, message: 'Network error, please check your connection' };
        }
        return response.json().catch(function () {
          return null;
        }).then(function (result) {
          if (!result) {
            return { code: 0, message: 'Invalid response format' };
          }
          return result;
        });
      }).catch(function () {
        return { code: 0, message: 'Subscription failed, please try again' };
      });
    }

    function getNewsletterMessage(key, fallback) {
      if (window.getFrontendMessage && typeof window.getFrontendMessage === 'function') {
        return window.getFrontendMessage(key, fallback);
      }

      return fallback;
    }

    function getSubscriptionResponseMessage(result, fallbackMessage) {
      var normalizedFallback = fallbackMessage || '';
      if (!result || typeof result !== 'object') {
        return normalizedFallback;
      }

      var candidate = String(result.message || '').trim();
      return candidate && candidate.toLowerCase() !== 'success'
        ? candidate
        : normalizedFallback;
    }

    function setupEmailInput(input) {
      if (!input) return;
      input.addEventListener('input', function (event) {
        var originalValue = event.target.value;
        var newValue = originalValue.replace(/\s/g, '');
        if (originalValue !== newValue) {
          event.target.value = newValue;
        }
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.keyCode === 32) {
          event.preventDefault();
        }
      });
    }

    function setupFacebookCommunityFlow() {
      setCommunityTriggerMode('facebook');
      setGlobalCommunityModalContent((config.modalContent && config.modalContent.facebook) || {});
      setNewsletterVisibility(true);
      setModalCtaVisibility(false);

      if (edmForm && edmEmailInput && edmMessage) {
        setupEmailInput(edmEmailInput);
        edmForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var email = edmEmailInput.value.trim();
          var validation = validateEmail(email);

          if (!validation.isValid) {
            edmMessage.textContent = validation.errorMessage;
            edmMessage.className = 'com__newsletter-error';
            edmMessage.style.display = 'block';
            return;
          }

          var btn = edmForm.querySelector('button');
          if (btn) {
            btn.disabled = true;
            btn.style.opacity = '0.6';
          }

          subscribeNewsletter(email).then(function (result) {
            if (btn) {
              btn.disabled = false;
              btn.style.opacity = '1';
            }

            var isSuccess = Boolean(result) && Number(result.code) === 200;
            if (isSuccess) {
              reportRokuCommunitySubscription(FB_JOIN_AD_VALUE.emailSubmit);
              var facebookGroupUrl = String((config.modalContent && config.modalContent.facebook && config.modalContent.facebook.buttonUrl) || '').trim();
              edmMessage.textContent = getSubscriptionResponseMessage(
                result,
                'Thank you! Your submission has been received!'
              );
              edmMessage.className = 'com__newsletter-error success';
              edmMessage.style.display = 'block';
              edmEmailInput.value = '';
              closeModal(edmModal);
              if (facebookGroupUrl) {
                trackFbRedirect(FB_REDIRECT_CHANNEL.emailSubmit);
                window.open(facebookGroupUrl, '_blank', 'noopener');
              }
            } else {
              edmMessage.textContent = getSubscriptionResponseMessage(
                result,
                getNewsletterMessage('emailInvalid', 'Email format incorrect, please try again.')
              );
              edmMessage.className = 'com__newsletter-error';
              edmMessage.style.display = 'block';
            }
          });
        });

        edmEmailInput.addEventListener('input', function () {
          edmMessage.style.display = 'none';
        });
      }
      var facebookUrl = String((config.modalContent && config.modalContent.facebook && config.modalContent.facebook.buttonUrl) || '').trim();
      communityTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        reportRokuCommunitySubscription(FB_JOIN_AD_VALUE.facebookIcon);

        if (facebookUrl) {
          // 所有国家都使用原来的Google Ads跟踪方式
          if (window.IS_PRODUCTION) {
            if (typeof window.reportGoogleAdsConversion === 'function') {
              window.reportGoogleAdsConversion((window.GOOGLE_ADS_CONVERSIONS || {}).joinFbGroup);
            }
          }

          // 美国、新加坡、英国、德国、法国：使用带 value/currency 的 Facebook 跟踪方式；其他国家保持原 Meta Pixel。
          if (isUSMarket() || isSingaporeMarket() || shouldUseLocalizedFbJoinTracking()) {
            trackFbRedirect(FB_REDIRECT_CHANNEL.facebookIcon);
          } else {
            if (window.IS_PRODUCTION) {
              if (typeof window.reportMetaPixelEvent === 'function') {
                window.reportMetaPixelEvent((window.META_PIXEL_EVENTS || {}).joinFbGroup);
              }
            }
          }

          window.open(facebookUrl, '_blank', 'noopener');
          return;
        }
        openModal(edmModal);
      });

      registerModalCloseButtons();
      registerModalInteractionDebug();
      document.addEventListener('keydown', handleModalKeydown);
      showCommunityTrigger();
      setupAutoTrigger(function () {
        openModal(edmModal);
      });
    }

    // Retired promo / take-drive coupon CTA flows.
    // function setupPromoFlow() { ... }
    // function setupTakeDrivePromoIconFlow() { ... }

    setupFacebookCommunityFlow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalCommunity, { once: true });
  } else {
    initGlobalCommunity();
  }
})();
